import {
    LIST_CHARACTERS,
    LIST_CHARACTERS_SUCCESS,
    LIST_CHARACTERS_ERROR,
    ADD_CHARACTERS,
    SAVE_CHARACTERS,
    SAVE_CHARACTERS_SUCCESS,
    SAVE_CHARACTERS_ERROR,
    DELETE_CHARACTERS,
    DELETE_CHARACTERS_SUCCESS,
    DELETE_CHARACTERS_ERROR,
    EDIT_CHARACTERS,
    UPDATE_CHARACTERS,
    UPDATE_CHARACTERS_SUCCESS,
    UPDATE_CHARACTERS_ERROR
} from '../types';

import clienteAxios from '../config/axios';

import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'caracter';

//LISTAR PERSON TYPES
export function listCharactersAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listCharacters() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const character = response.data;
            //Llamo al dispatch
            dispatch( listCharactersSuccess(character.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listCharactersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listCharacters = () => ({
    type: LIST_CHARACTERS,
    payload: true
});

const listCharactersSuccess = character => ({
    type: LIST_CHARACTERS_SUCCESS,
    payload: character
});

const listCharactersError = error => ({
    type: LIST_CHARACTERS_ERROR,
    payload: error
});

//ADD PERSON TYPE
export function addCharactersAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addCharacters(false) );
        //Abro el formulario
        showForm();
    }
}

const addCharacters = isEdit => ({
    type: ADD_CHARACTERS,
    payload: isEdit
});

//SAVE PERSON TYPE
export function saveCharactersAction(character, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveCharacters() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, character);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveCharactersSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveCharactersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveCharacters = () => ({
    type: SAVE_CHARACTERS,
    payload: true
});


const saveCharactersSuccess = character => ({
    type: SAVE_CHARACTERS_SUCCESS,
    payload: character
});

const saveCharactersError = error => ({
    type: SAVE_CHARACTERS_ERROR,
    payload: error
});

//EDIT PERSON TYPE
export function editCharactersAction(character, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editCharacters(character) );
        //Abro el formulario
        showForm();
    }
}

const editCharacters = character => ({
    type: EDIT_CHARACTERS,
    payload: character
});

//UPDATE PERSON TYPE
export function updateCharactersAction(character, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateCharacters() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${character.id}`, character);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateCharactersSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateCharactersError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateCharacters = () => ({
    type: UPDATE_CHARACTERS,
    payload: true
});

const updateCharactersSuccess = character => ({
    type: UPDATE_CHARACTERS_SUCCESS,
    payload: character
});

const updateCharactersError = error => ({
    type: UPDATE_CHARACTERS_ERROR,
    payload: error
});

//DELETE PERSON TYPE
export function deleteCharactersAction(character) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteCharacters() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${character.id}`);
            const response = await clienteAxios.put(`/${controller}/${character.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteCharactersSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteCharactersError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteCharacters = () => ({
    type: DELETE_CHARACTERS,
    payload: true
});

const deleteCharactersSuccess = character => ({
    type: DELETE_CHARACTERS_SUCCESS,
    payload: character
});

const deleteCharactersError = error => ({
    type: DELETE_CHARACTERS_ERROR,
    payload: error
});